import { Box } from "@mui/material";
import InboundsCard from "../../cards/inbounds/InboundsCard";
import ShCopyButton from "../../../theme/ShCopy";
import ShLabel from "../../../theme/label/ShLabel";
import ShLabelSkeleton from "../../../theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import Text from "../../../theme/text/Text";
import { getInboundStateData } from "../../../../utils/labelColorText";
import LabelNotice from "../../../theme/label/LabelNotice";

export const rhInboundColumns =  (i18n,theme,t,colors,columnStrategy) => {
    
    return [
      {field: "barcode", headerName: t("purchase_order"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return(
                    <Text>
                        {params.row.barcode}
                    </Text>
                )
            }
        },
        {
            field: "reference", 
            headerName: t("reference"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text noBreak>{params.row.reference}</Text>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.reference}
                        ></ShCopyButton>
                    </Box>
                )
            }
        },
        {
            field: "shipmentDate", 
            headerName: t("shipment_date"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = new Date(params.row.shipmentDate);
              
                return (
                    <Text>
                        {date.toLocaleDateString(i18n.language)}
                    </Text>
                );
            }
        },
        {field: "skuCount", headerName: t("sku_count"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.skuCount;
            }
        },
        {field: "itemCount", headerName: t("items"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.itemCount;
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const { labelcolor, labeltext, extraLabel } = getInboundStateData(params.row.state, theme, params.row.incompleteReceived);
              
                return (
                    <Box sx={{display:"flex", alignItems:"center", gap:1}}>
                        <ShLabel size={32} palette="normal" variant={labelcolor}>
                          {t(labeltext)}
                        </ShLabel>
                        {extraLabel && <LabelNotice text={t(extraLabel.labeltext)}/>}
                    </Box>
                  );
              }
        },
        {
            field: "receivedFromDate", 
            headerName: t("received_date"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                if(params.row.receivedFromDate === null ) {
                    return <Text>-</Text>
                }
                let date = new Date(params.row.receivedFromDate);
              
                return (
                    <Text>
                        {date.toLocaleDateString(i18n.language)}
                    </Text>
                );
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <InboundsCard 
                        // onClick={() => getInboundDetails(params)} 
                        skeleton={params.row.skeleton ?? false} 
                        {...params.row} 
                    />
                )
            }
        }
    ]
};